var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('TopNavigation'),_c('SideNavigation'),_c('v-main',[_c('router-view')],1),_c('notifications',{staticClass:"alerts",attrs:{"position":"bottom left"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }